define('C3.ShoppingExtensions.HeaderMenu.AdditionalLevel.ExtraLayer.View'
, 	[
		'c3_additional_levels_extralayer.tpl',
		'Profile.Model',
		//'SC.Configuration',
		'Utils',
		'SCView'
	],
function (
		c3_additional_levels_extralayer_tpl,
		ProfileModel,
		//Configuration,
		Utils,
		SCViewModule
){
	'use strict';

	 var SCView = SCViewModule.SCView;

	  function AdditionalLevelExtraLayerView (options) {
        SCView.call(this, options);

        this.template = c3_additional_levels_extralayer_tpl;
        this.options = options;
        this.application = options.application;
        this.additionallevels = options.additionallevels;
        this.configuration = options.configuration;
        this.parentlink = options.parentlink;
        this.parentname = options.parentname;
        console.log(this.configuration.get('currentTouchpoint'))
       
    }

    AdditionalLevelExtraLayerView.prototype = Object.create(SCView.prototype);
    AdditionalLevelExtraLayerView.prototype.constructor = AdditionalLevelExtraLayerView;

    AdditionalLevelExtraLayerView.prototype.getContext = function () {

        return {
           parentName : this.parentname || '',
           parentLink : this.parentlink || '',
           additionalLevels : this.additionallevels || [],
           currentTouchPoint : this.configuration.get('currentTouchpoint') || 'home'
        }
    }

    return AdditionalLevelExtraLayerView
});
